var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4994 35.7147C33.6554 35.7147 36.2137 33.1563 36.2137 30.0004C36.2137 26.8445 33.6554 24.2861 30.4994 24.2861C27.3435 24.2861 24.7852 26.8445 24.7852 30.0004C24.7852 33.1563 27.3435 35.7147 30.4994 35.7147Z",
    stroke: "#0516C8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4998 24.2859V15.1431M36.2141 44.8574V41.4288H40.7855C41.3918 41.4288 41.9731 41.188 42.4018 40.7593C42.8304 40.3307 43.0713 39.7493 43.0713 39.1431V30.0002C43.0717 27.6827 42.4315 25.4102 41.2214 23.4337C40.0113 21.4572 38.2784 19.8536 36.2141 18.8002M24.7855 18.8002C22.7204 19.853 20.9866 21.4563 19.7756 23.4328C18.5647 25.4094 17.9238 27.6822 17.9238 30.0002C17.9238 32.3182 18.5647 34.5911 19.7756 36.5676C20.9866 38.5442 22.7204 40.1474 24.7855 41.2002V44.8574",
    stroke: "#0516C8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7cc07b3d89d139e9dbc7c2907986830b.svg";
export { ForwardRef as ReactComponent };